export const iconFontAwesomeDisasterCrisisWorm = (
	<i className="fa-solid fa-worm"></i>
);
